import React from "react";
import PropTypes from "prop-types";

import DownloadButton from "./DownloadButton";
import ChangeSize from "./ChangeSize";

import { DownloadButtonsContainer } from "./styles";

import { DOWNLOAD_TYPES } from "icons/helpers";
import useIconDownloadSize from "frontend/hooks/useIconDownloadSize";

const DownloadButtons = ({
    icon,
    showChangeSize = false,
    handleDownloadSuccess,
    handleDownloadFailure
}) => {
    const [downloadSize, setDownloadSize] = useIconDownloadSize({
        isBasic: !showChangeSize
    });

    return (
        <>
            <DownloadButtonsContainer>
                {DOWNLOAD_TYPES.map(downloadType => (
                    <DownloadButton
                        key={downloadType}
                        downloadType={downloadType}
                        downloadSize={downloadSize}
                        icon={icon}
                        onFail={handleDownloadFailure}
                        onDownload={handleDownloadSuccess}
                    />
                ))}
                {showChangeSize && (
                    <ChangeSize
                        downloadSize={downloadSize}
                        setDownloadSize={setDownloadSize}
                    />
                )}
            </DownloadButtonsContainer>
        </>
    );
};

DownloadButtons.propTypes = {
    icon: PropTypes.object.isRequired,
    showChangeSize: PropTypes.bool,
    handleDownloadSuccess: PropTypes.func,
    handleDownloadFailure: PropTypes.func.isRequired
};

export default DownloadButtons;
